module.exports = __webpack_public_path__ + "static/media/icon_dryer.55740047.svg";